import { useState } from 'react';

export interface Row {
  uuid?: string | null;
  [key: string]: any;
}

export interface SelectedCellInfo {
  id: string;
  field: string;
}

export interface BulkDeleteCellParams {
  id: string | number;
  row: Row;
}

export function useTable(initialRows: Row[] = []) {
  const [rows, setRows] = useState<Row[]>(initialRows);
  const [selectedRowUuid, setSelectedRowUuid] = useState<string | null>(null);
  const [selectedRow, setSelectedRow] = useState<Row | null>(null);

  const handleRowClick = (params: { id: string; row: Row }) => {
    const rowUuid = params.id || params.row?.uuid;
    if (!rowUuid) return;

    setSelectedRowUuid(rowUuid);
    setSelectedRow(params.row);
  };
  const handleDeleteRow = () => {
    let updatedRows: Row[] = [];

    if (selectedRowUuid) {
      updatedRows = rows.filter(row => row.uuid !== selectedRowUuid);
      setRows(updatedRows);
    } else if (rows.length > 0) {
      updatedRows = rows.slice(0, -1);
      setRows(updatedRows);
    }

    // If there are remaining rows, select the last one
    if (updatedRows.length > 0) {
      const lastRow = updatedRows[updatedRows.length - 1];
      setSelectedRowUuid(lastRow.uuid || null);
      setSelectedRow(lastRow);
    } else {
      // If no rows remain, clear selection
      clearSelection();
    }
  };

  const handleCellClick = (params: BulkDeleteCellParams) => {
    const rowUuid = params.id.toString();
    if (!rowUuid) return;

    // Update row selection
    setSelectedRowUuid(rowUuid);
    setSelectedRow(params.row);
  };

  const clearSelection = () => {
    setSelectedRowUuid(null);
    setSelectedRow(null);
  };

  return {
    rows,
    setRows,
    selectedRowUuid,
    selectedRow,
    handleRowClick,
    handleDeleteRow,
    handleCellClick,
    clearSelection
  };
}
